import request from './requestWrapper';

// Types
import {UserStoreMapType, UserStorePaginationType} from "../types/userStoreMapTypes";


function getParams() {
  return request({
    url: 'userStoreMap/getParams',
    method: 'GET',
  });
}
function getAll(data: UserStorePaginationType) {
  return request({
    url: 'userStoreMap/getAll',
    method: 'POST',
    data: data
  });
}
function update(id: string, userStoreMap: UserStoreMapType) {
  return request({
    url: `userStoreMap/update/${id}`,
    method: 'PATCH',
    data: userStoreMap
  });
}
function sync() {
  return request({
    url: 'userStoreMap/sync',
    method: 'GET',
  });
}

export default {
  getParams,
  getAll,
  update,
  sync
}